import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCopy({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M13.87 2.8l-1.42-1.42a1.31 1.31 0 00-.93-.38h-4.7c-.73 0-1.32.59-1.32 1.31v1.31H3.31C2.6 3.63 2 4.22 2 4.95v8.75c0 .7.59 1.3 1.31 1.3h6.13c.72 0 1.31-.59 1.31-1.31v-1.31h2.19c.72 0 1.31-.6 1.31-1.32V3.73c0-.35-.14-.68-.38-.93zm-4.6 10.9h-5.8a.16.16 0 01-.16-.17V5.1c0-.09.08-.16.17-.16H5.5v6.12c0 .73.59 1.31 1.31 1.31h2.63v1.15c0 .1-.08.17-.17.17zm3.5-2.63h-5.8a.16.16 0 01-.16-.16V2.48c0-.1.08-.17.17-.17h2.9v2.4c0 .37.29.67.65.67h2.4v5.52c0 .09-.07.16-.16.16zm.17-7h-1.75V2.31h.26c.04 0 .09.02.12.05l1.32 1.32c.03.03.05.08.05.12v.26z" />
    </svg>
  );
}

SvgBasicCopy.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCopy.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicCopy svgRef={ref} {...props} />);
export default ForwardRef;
